import { render, staticRenderFns } from "./ModalEditSpace.vue?vue&type=template&id=53d48d00"
import script from "./ModalEditSpace.vue?vue&type=script&lang=js"
export * from "./ModalEditSpace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports